import { InMemoryCache } from '@apollo/client'

// The cache cannot handle offset-limit pagination if the arguments are not on the array field, like in our case.
// This config makes these 'query(offset, limit) { id, total, items }' structures cached in-place instead of being
// normalized.
const offsetLimitPaginationWithNestedItemsArrayPolicy = {
  keyFields: false as const,
  // @ts-expect-error Not sure about the types
  merge(existing, incoming, { mergeObjects }) {
    return mergeObjects(existing, incoming)
  },
}

export const cache = new InMemoryCache({
  resultCacheMaxSize: 200 * 1024 * 1024, // 200 MB
  typePolicies: {
    AppList: offsetLimitPaginationWithNestedItemsArrayPolicy,
    AppDeploymentList: offsetLimitPaginationWithNestedItemsArrayPolicy,
    DatabaseList: offsetLimitPaginationWithNestedItemsArrayPolicy,
    StaticSiteList: offsetLimitPaginationWithNestedItemsArrayPolicy,
    ObjectStorageList: offsetLimitPaginationWithNestedItemsArrayPolicy,
    EdgeLoadBalancerList: offsetLimitPaginationWithNestedItemsArrayPolicy,
    ProjectList: offsetLimitPaginationWithNestedItemsArrayPolicy,
    StaticSiteDeploymentList: offsetLimitPaginationWithNestedItemsArrayPolicy,
    BlockedGitOrganizations: offsetLimitPaginationWithNestedItemsArrayPolicy,
    TemplateList: offsetLimitPaginationWithNestedItemsArrayPolicy,
  },
})
